var map = {
	"./": 480,
	"./OldUi": 2686,
	"./OldUi.js": 2686,
	"./SpireonNew": 2687,
	"./SpireonNew.js": 2687,
	"./SpireonOld": 2688,
	"./SpireonOld.js": 2688,
	"./index": 480,
	"./index.js": 480,
	"./style": 369,
	"./style.js": 369
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4192;